import { server } from '../server';
export const searchAgents = async (chainLayer, search, first = 50, skip = 0) => {
    const page = Math.floor(skip / first);
    const size = first;
    const queryParams = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
        search,
    });
    const response = await server.get({
        endpoint: 'search',
        queryParams,
        chainLayer,
    });
    if (!response.ok) {
        throw new Error(`Error searching agents: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};
